const ROLE_KEY_MAP = {
  employee: 'roleEmployee',
  admin: 'roleAdmin',
  reader: 'roleReader',
  super_admin: 'roleSuperAdmin'
};

export const formatRoleLabel = (role, t) => {
  if (!role) {
    return '—';
  }
  const key = ROLE_KEY_MAP[role];
  return key ? t(`common:${key}`) : role;
};
